import { render, staticRenderFns } from "./RejectedReason.vue?vue&type=template&id=51dde11c&scoped=true&"
import script from "./RejectedReason.vue?vue&type=script&lang=js&"
export * from "./RejectedReason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51dde11c",
  null
  
)

export default component.exports